import React, { useRef } from 'react';
import * as S from './styles';

function Home1() {
  const divRef = useRef<HTMLDivElement | null>(null); // Especificando que o ref pode ser de um HTMLDivElement ou null

  const scrollToDiv = () => {
    divRef.current && divRef.current.scrollIntoView({ behavior: 'smooth' }); // Scroll suave até a div
  };

  return (
    <S.Main>
      <S.Section>
        <S.TextDiv>
          <div>
            <h3>Fale com a gente</h3>
          </div>
          <p>Entre em contato através de um de nossos canais.</p>
        </S.TextDiv>
      </S.Section>
      <div ref={divRef} />
    </S.Main>
  );
}

export default Home1;
